import React from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Icon,
  message,
  Modal,
  Row,
  Switch,
  Tooltip,
} from "antd";
import { withRouter } from "react-router";

import {
  activateSubjectRequest,
  deleteSubjectRequest,
  getCustomFormData,
  getCustomFormSchema,
  getRandomizationSites,
  lockSubjectRequest,
  unlockSubjectRequest,
  updateSubjectRequest,
} from "../../api/requests";
import isAuthenticated from "../../utils/isAuthenticated";

import classes from "./PatientProfileForm.css";

import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import FormBuilderCustomView from "../../containers/FormBuilder/FormBuilderCustomView";
import {
  getPatientProfileCreatePermission,
  getPatientProfileDeletePermission,
  getPatientProfileLockPermission,
  getPatientProfileUnlockPermission,
  getPatientProfileUpdatePermission,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import { connect } from "react-redux";
import PatientProfileDeleteForm from "./PatientProfileDeleteForm";

class PatientProfileFormRandomization extends React.Component {
  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      date: "",
      studyID: "",
      show_voided: queryParams.get("show_voided"),
      dose: "",
      consentType: "",
      loading: true,
      isEditable: true,
      sites: [],
      locked: false,
      locked_date: null,
      requestResult: {},
      formData: {},
      deleteSubmitModal: false,
      activateSubmitModal: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });

    try {
      const { data } = await getRandomizationSites();
      const { data: formSchema } = await getCustomFormSchema("randomization");
      const { data: formData } = await getCustomFormData(
        "randomization",
        this.props.subjectID
      );

      this.setState({
        sites: data.filter((item) => item.site_type === "randomization"),
        formSchema,
        formData,
        locked: get(this.props.profile, "locked"),
        locked_date: get(this.props.profile, "locked_date"),
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.subjectID !== this.props.subjectID) {
      this.setState({
        requestResult: {},
        locked: get(this.props, "profile.locked"),
      });
    }

    if (prevProps.randomized !== this.props.randomized) {
      this.setState({ requestResult: {}, locked: false });
    }
  }

  onSwitchLock = async () => {
    try {
      if (this.state.locked) {
        await unlockSubjectRequest(this.props.subjectID);
        this.setState({ locked: false, locked_date: null });
      } else {
        await lockSubjectRequest(this.props.subjectID);
        this.setState({ locked: true, locked_date: new Date() });
      }
      message.success("Saved");
      this.props.onSubmit(this.props.subjectID);
    } catch (e) {
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
    }
  };

  handleSubmit = async (values) => {
    const schema = get(this.state, "formSchema.schema");
    const isUpload = Object.keys(schema).some((k) =>
      Object.keys(schema[k].fields).some(
        (o) => schema[k].fields[o].type === "InputUpload"
      )
    );

    let data = {};

    if (isUpload) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] && values[key].file) {
          formData.append(key, values[key].file);
        } else {
          formData.append(key, values[key]);
        }
      });

      data = formData;
    } else {
      data = { ...values };
    }

    await updateSubjectRequest(this.props.subjectID, data);
    this.props.onSubmit(this.props.subjectID);

    this.setState({
      loading: false,
    });
  };

  handleReset() {
    this.setState({
      date: "",
      studyID: "",
      dose: "",
      loading: false,
      isEditable: false,
    });
  }

  showDeleteModal = () => {
    this.setState({ deleteSubmitModal: true });
  };
  hideDeleteModal = () => {
    this.setState({ deleteSubmitModal: false });
  };

  showActivateModal = () => {
    this.setState({ activateSubmitModal: true });
  };
  hideActivateModal = () => {
    this.setState({ activateSubmitModal: false });
  };

  submitDeletePatient = async () => {
    const { patientProfileDeletePermission } = this.props;

    if (patientProfileDeletePermission) {
      try {
        await deleteSubjectRequest(this.props.subjectID);
        this.hideDeleteModal();
        message.success(this.props.i18n.t("Saved"));
        this.props.onSubmit(this.props.subjectID);
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
        }
      }
    }
  };

  activateSubject = async () => {
    const { patientProfileDeletePermission } = this.props;

    if (patientProfileDeletePermission) {
      try {
        await activateSubjectRequest(this.props.subjectID);
        message.success(this.props.i18n.t("Saved"));
        this.props.onSubmit(this.props.subjectID);
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
        } else {
          message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
        }
      }
    }
  };

  render() {
    const {
      profile,
      site,
      patientProfileCreatePermission,
      patientProfileUpdatePermission,
      patientProfileDeletePermission,
      state,
      patientProfileLockPermission,
      patientProfileUnlockPermission,
      isNew,
      subject,
    } = this.props;

    const {
      loading,
      sites,
      formSchema,
      isEditable,
      locked,
      formData,
      requestResult,
      activateSubmitModal,
      deleteSubmitModal,
    } = this.state;

    return (
      <Row>
        <Col md={24} lg={18}>
          {!loading && (
            <div>
              {formSchema ? (
                <FormBuilderCustomView
                  initialValues={profile}
                  compareValues={get(
                    formData.model_results[formData.model_results.length - 1],
                    "data"
                  )}
                  site={site}
                  sites={sites}
                  isEditable={
                    !locked && subject.state === "active" && isEditable && patientProfileUpdatePermission
                  }
                  schema={formSchema.schema}
                  name={formSchema.name}
                  slug="randomization"
                  preChildren={this.getPreChildren}
                  onSubmit={this.handleSubmit}
                  relatedSubjectData={subject ? subject : null}
                />
              ) : (
                <Icon type="loading" />
              )}
            </div>
          )}

              {!loading && subject && get(subject, "comments") && (
                  <div>
                    <hr/>
                    <b>{this.props.i18n.t('Comments')}:</b>
                    <div>
                      <p><i>{get(subject, "comments")}</i></p>
                    </div>
                  </div>
              )}
          <div className={classes.saveWrapper}>
            {requestResult.type && (
              <Alert
                message={requestResult.message}
                type={requestResult.type}
                className={classes.submitResult}
              />
            )}

            <Form.Item className={classes.formActions}>
              {this.props.profile && (
                <Tooltip
                  placement="topLeft"
                  title={this.props.i18n.t(
                    "NamespacePatientProfileForm:Lock / Unlock the Subject Profile"
                  )}
                >
                  {this.props.i18n.t("NamespacePatientProfileForm:Lock status")}
                  : &nbsp;
                  <Switch
                    disabled={
                      (!patientProfileUnlockPermission && locked) ||
                      (!patientProfileLockPermission && !locked)
                    }
                    checked={locked}
                    onChange={this.onSwitchLock}
                  />
                </Tooltip>
              )}

              {patientProfileDeletePermission &&
                isEditable &&
                subject.state === "active" &&
                !isNew && (
                  <PatientProfileDeleteForm subjectID={this.props.subjectID} locked={locked} onProfileDelete={this.props.onProfileDelete} />
                  /*<Button
                    type="primary"
                    size="large"
                    htmlType="button"
                    className={classes.deleteButton}
                    onClick={this.showDeleteModal}
                  >
                    {this.props.i18n.t("Deactivate")}
                  </Button>*/
                )}
              {patientProfileUpdatePermission &&
                subject.state !== "active" &&
                !isNew && (
                  <Button
                    type="primary"
                    size="large"
                    htmlType="button"
                    disabled={locked}
                    onClick={this.showActivateModal}
                  >
                    {this.props.i18n.t("Activate")}
                  </Button>
                )}
            </Form.Item>
          </div>
        </Col>

        <Modal
          title={this.props.i18n.t(
            "NamespacePatientProfileForm:Subject deactivation"
          )}
          visible={deleteSubmitModal}
          onOk={this.submitDeletePatient}
          onCancel={this.hideDeleteModal}
        >
          <p>
            {this.props.i18n.t(
              "NamespacePatientProfileForm:Confirm patient deactivate action"
            )}
          </p>
        </Modal>

        <Modal
          title={this.props.i18n.t("Subject activation")}
          visible={activateSubmitModal}
          onOk={this.activateSubject}
          onCancel={this.hideActivateModal}
        >
          <p>
            {this.props.i18n.t(
              "NamespacePatientProfileForm:Confirm patient activate action"
            )}
          </p>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  patientProfileCreatePermission: getPatientProfileCreatePermission(state),
  patientProfileUpdatePermission: getPatientProfileUpdatePermission(state),
  patientProfileDeletePermission: getPatientProfileDeletePermission(state),
  patientProfileLockPermission: getPatientProfileLockPermission(state),
  patientProfileUnlockPermission: getPatientProfileUnlockPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(PatientProfileFormRandomization)))
);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientProfileFormRandomization.js